import type { SupabaseClient } from '@supabase/supabase-js';

export interface WorkSchedule {
  diaSemana: number;
  horaFin: string;
  horaInicio: string;
  id: string;
}

export interface ScheduleInput {
  dia_semana: number;
  hora_fin: string;
  hora_inicio: string;
}

interface ScheduleRow {
  dia_semana: number;
  hora_fin: string;
  hora_inicio: string;
  id: string;
}

const DAYS_OF_WEEK = [1, 2, 3, 4, 5, 6, 7];

export const DAY_LABELS: Record<number, string> = {
  1: 'Lunes',
  2: 'Martes',
  3: 'Miercoles',
  4: 'Jueves',
  5: 'Viernes',
  6: 'Sabado',
  7: 'Domingo',
};

export function getDefaultSchedules(): ScheduleInput[] {
  return DAYS_OF_WEEK.map((day) => ({
    dia_semana: day,
    hora_inicio: day === 7 ? '' : '09:00',
    hora_fin: day === 7 ? '' : '18:00',
  }));
}

export async function fetchWorkSchedules(
  client: SupabaseClient,
  professionalId: string
): Promise<WorkSchedule[]> {
  const res = await client
    .schema('oyb')
    .from('horarios_laborales_profesional')
    .select('id, dia_semana, hora_inicio, hora_fin')
    .eq('profesional_id', professionalId)
    .order('dia_semana', { ascending: true })
    .returns<ScheduleRow[]>();

  if (res.error) throw res.error;

  return (res.data ?? []).map((row) => ({
    diaSemana: row.dia_semana,
    horaFin: row.hora_fin,
    horaInicio: row.hora_inicio,
    id: row.id,
  }));
}

export async function upsertWorkSchedules(
  client: SupabaseClient,
  professionalId: string,
  schedules: ScheduleInput[]
): Promise<void> {
  await client
    .schema('oyb')
    .from('horarios_laborales_profesional')
    .delete()
    .eq('profesional_id', professionalId);

  const validSchedules = schedules.filter((s) => s.hora_inicio && s.hora_fin && s.hora_inicio < s.hora_fin);

  if (validSchedules.length === 0) return;

  const res = await client
    .schema('oyb')
    .from('horarios_laborales_profesional')
    .insert(
      validSchedules.map((s) => ({
        profesional_id: professionalId,
        dia_semana: s.dia_semana,
        hora_inicio: s.hora_inicio,
        hora_fin: s.hora_fin,
      }))
    );

  if (res.error) throw res.error;
}
